<app-header *ngIf="showPageContent" id="headerTitle"></app-header>
<ngx-ui-loader *ngIf="showPageContent"></ngx-ui-loader>
<!-- <app-notification-message class="notf"></app-notification-message> -->
<!-- <app-breadcrumb class="breadcrumbz" *ngIf="showPageContent"></app-breadcrumb> -->
<router-outlet class="container-div"></router-outlet>
<!-- <app-footer *ngIf="showPageContent"></app-footer> -->
<app-unauthorized *ngIf="isUnauthorized"></app-unauthorized>